import PropTypes from "prop-types";
import { Box } from "@mui/material";
// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object,
};

export default function Logo({ width = "auto" }) {
  return (
    <Box component="h2" textAlign="center" fontSize={{ xs: "1em", md: "1.5em" }} className="text-gradient">
      Smart EV Charging Management System
    </Box>
  );
}